export const actionTypes = {
  // GET
  GET_ACTIVITY_LOG_START: 'GET_ACTIVITY_LOG_START',
  GET_ACTIVITY_LOG_SUCCESS: 'GET_ACTIVITY_LOG_SUCCESS',
  GET_ACTIVITY_LOG_FINISH: 'GET_ACTIVITY_LOG_FINISH',
}
